import { createProvider } from '@nvision/services/data-provider';
import { queryOptions } from '@tanstack/react-query';

import type { LaneItem } from '../../models';
import { CACHE_KEYS } from '../../types';
import { logger } from '../../utils/logger';
import { api } from './api';

export const fetchLane = createProvider(api.fetchLane)
  .andThen((res) => res)
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      logger.warn('Fetch lanes search results list aborted');
    } else {
      logger.error('Fetch lanes search results list was failed:', error);
    }
    throw error;
  });

export const laneOptions = (laneKey: LaneItem['laneKey']) =>
  queryOptions({
    enabled: Boolean(laneKey),
    queryFn: ({ signal }) => fetchLane(laneKey, { signal }),
    queryKey: CACHE_KEYS.lane(laneKey),
  });
